export function getPostScanConfig(state) {
  return state?.user?.settings?.data?.post_scanning_config || null;
}

export function getPostScanModulesFromConfig(config) {
  const modules = Array.isArray(config?.modules) ? config.modules : [];
  const enabled = Boolean(config?.psv2_enabled) && modules.length > 0;
  return {enabled, modules};
}

export function getPostScanModules(state) {
  return getPostScanModulesFromConfig(getPostScanConfig(state));
}

// Mirrors the legacy chain rules: nothing runs when the first slot is unset, and
// a second slot equal to the first is dropped.
export function getLegacyPostScanSteps(scanPackSettings) {
  const first = scanPackSettings?.post_scanning_option;
  const second = scanPackSettings?.post_scanning_option_second;
  if (!first || first === 'None') return [];
  const steps = [first];
  if (second && second !== 'None' && second !== first) steps.push(second);
  return steps;
}

// v2 fully overrides v1 when enabled; v1 is never consulted in that case.
export function getPostScanStepsFromConfigs(postScanConfig, scanPackSettings) {
  const {enabled, modules} = getPostScanModulesFromConfig(postScanConfig);
  if (enabled) return {version: 'v2', steps: modules};
  return {version: 'v1', steps: getLegacyPostScanSteps(scanPackSettings)};
}

export function getPostScanSteps(state) {
  return getPostScanStepsFromConfigs(
    getPostScanConfig(state),
    state?.user?.bothSettings?.data?.data?.scanpack_setting
  );
}
